import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CustomerStoreService } from '../../services/customer-store.service';
import { Router } from '@angular/router';
import { HintTileConfig } from '../../../shared/atoms/hint-tile/hint-tile.component';
import { TranslateService } from '@ngx-translate/core';
import { BdoApiService } from '../../services/bdo-api.service';
import { ALERT_TYPE } from '../../enums/alertType.enum';
import { TRACKING } from '../../enums/trackingParts.enum';
import { TrackingService } from '../../services/tracking.service';

@Component({
    selector: 'bdo-personal-data',
    templateUrl: './personal-data.component.html',
    styleUrls: ['./personal-data.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PersonalDataComponent implements OnInit {
  public disabled: boolean = false;

  public accountId: string;
  public optInEditTriggeredByPopup: boolean;
  public currentTileConfig: HintTileConfig;

  constructor(
    private router: Router,
    private customerStore: CustomerStoreService,
    private translateService: TranslateService,
    private apiService: BdoApiService,
    private trackingService: TrackingService,
  ) { }

  ngOnInit(): void {
    this.accountId = this.customerStore.getAccountId();
    this.optInEditTriggeredByPopup = this.router.url.includes('optin') && this.router.currentNavigation().extras.state?.isEdit;
    if ( this.router.url.includes('confirmPersonalData')) {
      this.currentTileConfig = {
        borderTopColor: 'red',
        iconPath: 'assets/icons/bell.svg',
        iconWithBadge: true,
        text: this.translateService.instant('personaldata.alert'),
        linkType: 'primaryButton',
        linkText: this.translateService.instant('personaldata.alertLinkText'),
        linkPath: '',
        isDashboardTile: true,
        accessibilityLabel: this.translateService.instant('dashboard.alertTile.accessibilityLabel.importantNotice'),
        accessibilityRole: 'alert'
      };
    }
    this.disabled = this.optInEditTriggeredByPopup || this.disabled;
  }

  onEditChange(isEditing: boolean, scrollToFragment: string) {
    this.disabled = isEditing;
    this.router.navigate([], { fragment: scrollToFragment, skipLocationChange: true });
  }

  confirmPersonalDataChecked() {
    this.trackingService.postSimpleTracking(TRACKING.LOCATION.PERSONAL_DATA, TRACKING.ACTION.CONFIRM);

    this.apiService.postAlert({ id: ALERT_TYPE.CONFIRM_PERSONAL_DATA }).subscribe(() => {
      this.currentTileConfig = null;
      this.router.navigate(['/dashboard'], { queryParams: {} });
    });
  }

}
